import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  y = 26,
  className
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-45" data-mp="3bie7zufj95r8">
      {children}
    </motion.div>;
}